import { breadcrumbConfig } from './breadcrumb-config';
import { resolveBreadcrumbLabel } from './helper';
import type { IBreadcrumbItem } from './types';

export function getBreadcrumbItemsForPathname(pathname: string): IBreadcrumbItem[] {
  const items: IBreadcrumbItem[] = [];

  const normalizedPathname = pathname || '/my';

  // The sys admin panel is its own rooted area ('/sys' = Mission Control), so it
  // does not show the user-area Home ('/my') crumb. Every other dashboard area does.
  const isSysPanel = normalizedPathname === '/sys' || normalizedPathname.startsWith('/sys/');

  if (!isSysPanel) {
    items.push({ label: breadcrumbConfig['/my'] || 'Home', href: '/my' });
  }

  if (normalizedPathname === '/my') {
    return items;
  }

  const pathSegments = normalizedPathname.split('/').filter(Boolean);
  const currentPathParts: string[] = [];

  for (const segment of pathSegments) {
    currentPathParts.push(segment);
    const currentPath = `/${currentPathParts.join('/')}`;

    if (currentPath === '/my') {
      continue;
    }

    items.push({ label: resolveBreadcrumbLabel(currentPath, segment), href: currentPath });
  }

  return items;
}
